import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'packages/theming';
import { Box, Button, Icon, Input, VisuallyHidden } from '@match/react-component-library';
import { Redirect } from 'react-router-dom';
import useSearch, { SEARCH_INPUT_ID } from './useSearch';

interface SearchProps {
  isMobi?: boolean;
}

const Search: React.FunctionComponent<SearchProps> = ({ isMobi = false, ...props }) => {
  const intl = useIntl();

  const searchText = React.useRef(intl.formatMessage(messages.searchPlaceholder));
  const submitText = React.useRef(intl.formatMessage(messages.submitText));

  const { getInputValue, submitStatus, onChange, onKeyDown, onSubmit } = useSearch();

  return (
    <Box
      display="flex"
      justifyContent={isMobi ? 'center' : 'flex-end'}
      alignItems="center"
      width="100%"
    >
      {submitStatus && <Redirect to={`/search?value=${getInputValue()}`} />}
      <StyledInput
        id={SEARCH_INPUT_ID}
        name="customselect"
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={searchText.current}
        type="search"
        variant="variant1"
        width={isMobi ? 300 : 340}
        {...props}
      />
      <SearchButton minimal shape="circle" onClick={onSubmit}>
        <VisuallyHidden>{submitText.current}</VisuallyHidden>
        <Icon name="discover" size="small" />
      </SearchButton>
    </Box>
  );
};

export default Search;

const StyledInput = styled(Input)(() => ({
  paddingRight: 50,
}));

const SearchButton = styled(Button)(() => ({
  marginLeft: -50,
  marginTop: -5,
}));

const messages = defineMessages({
  clearFieldLabel: {
    id: 'src/modules/components/Search/Search:clearFieldLabel',
    description: 'clear field label',
    defaultMessage: 'Clear Field',
  },
  searchPlaceholder: {
    id: 'src/modules/components/Search/Search:searchPlaceholder',
    description: 'search input placeholder text',
    defaultMessage: 'Search',
  },
  submitText: {
    id: 'src/modules/components/Search/Search:submitText',
    description: 'button text to submit search query',
    defaultMessage: 'Submit Search',
  },
});
